import React, { useEffect, useState } from "react"
import { getStockRightFSDataSSE } from "../../../modules/quote/web"
import "./index.less"
import { quote_fs_trade_info, quote_item_fs_trade_info, quote_item_trade_info, quote_trade_info } from "../../shared/quotedata/index"
import { store } from "./store"
import { Observer } from "mobx-react-lite"
import { quotedata } from "../../shared/quotedata"

export function BTimeTrade(props: { quotedata: quotedata }) {
  const [expandFS, setExpandFS] = useState({ expand: false, iconRotate: false })
  const [tradeData, setTradeData] = useState<Array<string>>([])
  const [lastItem, setLastItem] = useState("")
  const [show_trade_number, setShowTradeNumber] = useState(7)

  const clickExpandFS = () => {
    if (!expandFS.expand) {
      setExpandFS({ expand: true, iconRotate: true })
      setShowTradeNumber(14)
    } else {
      setExpandFS({ expand: false, iconRotate: false })
      setShowTradeNumber(7)
    }
  }

  const clickMore = () => {
    location.href = `/quote/stockmore_new.html?id=${props.quotedata.code}&mk=${props.quotedata.market}&tab=2`
  }

  useEffect(() => {
    let sse = getStockRightFSDataSSE(props.quotedata.quotecode, (data: any) => {
      setLastItem(data[0])
      setTradeData(data)
    })
    return () => {
      try {
        sse.close()
      } catch (error) {}
    }
  }, [])

  return (
    <Observer>
      {() => (
        <>
          <div className={`${expandFS.expand ? "expand-fenshi" : ""}`}>
            <div className="content-hq">
              {store.StockDetail && (
                <>
                  <SellAndBuy />
                  <ul className="tb-fenshi">
                    <li onClick={clickExpandFS}>
                      <a>
                        分时成交 <i className={`icon-trangle ${expandFS.iconRotate ? "rotate" : ""}`}></i>
                      </a>
                    </li>
                    <>
                      {tradeData.length > 0 &&
                        tradeData.map((item: any, index: number) => {
                          return (
                            index < show_trade_number && (
                              <li key={index}>
                                {quote_fs_trade_info[quote_item_fs_trade_info.时间](item).element}
                                {quote_fs_trade_info[quote_item_fs_trade_info.成交价](tradeData, lastItem, item, index, store.StockDetail).newElement}
                                {quote_fs_trade_info[quote_item_fs_trade_info.成交量](item).element}
                              </li>
                            )
                          )
                        })}
                    </>
                    <li>
                      <a
                        href="#"
                        className="more-fenshi"
                        onClick={(e) => {
                          e.preventDefault()
                          clickMore()
                        }}
                      >
                        更多成交
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </Observer>
  )
}

function SellAndBuy() {
  return (
    <>
      <ul className="tb-sell">
        <li>
          <span>卖5</span>
          {quote_trade_info[quote_item_trade_info.卖5价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖5量](store.StockDetail).element}
        </li>
        <li>
          <span>卖4</span>
          {quote_trade_info[quote_item_trade_info.卖4价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖4量](store.StockDetail).element}
        </li>
        <li>
          <span>卖3</span>
          {quote_trade_info[quote_item_trade_info.卖3价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖3量](store.StockDetail).element}
        </li>
        <li>
          <span>卖2</span>
          {quote_trade_info[quote_item_trade_info.卖2价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖2量](store.StockDetail).element}
        </li>
        <li>
          <span>卖1</span>
          {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.卖1量](store.StockDetail).element}
        </li>
      </ul>
      <ul className="tb-buy">
        <li>
          <span>买1</span>
          {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买1量](store.StockDetail).element}
        </li>
        <li>
          <span>买2</span>
          {quote_trade_info[quote_item_trade_info.买2价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买2量](store.StockDetail).element}
        </li>
        <li>
          <span>买3</span>
          {quote_trade_info[quote_item_trade_info.买3价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买3量](store.StockDetail).element}
        </li>
        <li>
          <span>买4</span>
          {quote_trade_info[quote_item_trade_info.买4价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买4量](store.StockDetail).element}
        </li>
        <li>
          <span>买5</span>
          {quote_trade_info[quote_item_trade_info.买5价](store.StockDetail).element}
          {quote_trade_info[quote_item_trade_info.买5量](store.StockDetail).element}
        </li>
      </ul>
    </>
  )
}
